import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../Messenger.css";
import MessageStatusTable from "./MessageStatusTable";
import LatestScheduledMessagesTable from "./LatestScheduledMessagesTable";
import MessageHistoryTable from "./MessageHistoryTable";
import constants from "../../../utils/constants";
import Banner from "../../../components/MessageManager/Banner";
import { useNavigate } from "react-router-dom";

function MessageStatus(props) {
  const navigate = useNavigate();
  const { user } = props;
  const permissionIds = user.permissions.map(permission => permission.id);

  if (!permissionIds.includes(constants.permissionIds.msgManagerFrontDeskView)) {
    navigate('/forbidden');
  }

  const [updateFlag, setUpdateFlag] = useState(false);

  const statusTableRef = useRef();
  const scheduledTableRef = useRef();
  const historyTableRef = useRef();

  const loadStatusTable = (loadFunction) => {
    statusTableRef.current = loadFunction;
  };

  const loadScheduledTable = (loadFunction) => {
    scheduledTableRef.current = loadFunction;
  };

  const loadHistoryTable = (loadFunction) => {
    historyTableRef.current = loadFunction;
  };

  useEffect(() => {
    let interval;
    let isMounted = true;
    const loadData = async () => {
      if (!isMounted) return;
      if (statusTableRef.current) await statusTableRef.current();
      if (scheduledTableRef.current) await scheduledTableRef.current();
      if (historyTableRef.current) await historyTableRef.current();
      interval = setTimeout(loadData, 5000);
    };
    loadData();
    return () => {
      isMounted = false;
      clearTimeout(interval);
    };
  }, []);

  return (
    <>
      <Banner />
      <MessageStatusTable
        updateFlag={updateFlag}
        setUpdateFlag={setUpdateFlag}
        onLoadStatusTable={loadStatusTable}
      />
      <LatestScheduledMessagesTable
        updateFlag={updateFlag}
        setUpdateFlag={setUpdateFlag}
        onLoadScheduledTable={loadScheduledTable}
      />
      <MessageHistoryTable
        updateFlag={updateFlag}
        onLoadHistoryTable={loadHistoryTable}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(MessageStatus);
